<template>
    <div class="container">
      <h1>Git CheatSheet</h1>
      <p class="description">Uma referência rápida para os comandos mais usados do Git.</p>
  
      <div class="cheat-sheet">
        <!-- Primeira Coluna -->
        <div class="column">
          <h2>📌 Configuração do Git</h2>
          <p><b>Definir usuário global:</b> <code>git config --global user.name "Seu Nome"</code></p>
          <p><b>Definir e-mail global:</b> <code>git config --global user.email "seu@email.com"</code></p>
          <p><b>Ver configurações:</b> <code>git config --list</code></p>
  
          <h2>📌 Inicializar e Clonar</h2>
          <p><b>Inicializar repositório:</b> <code>git init</code></p>
          <p><b>Clonar um repositório:</b> <code>git clone URL</code></p>
  
          <h2>📌 Trabalhando com Commits</h2>
          <p><b>Adicionar arquivos:</b> <code>git add arquivo.txt</code></p>
          <p><b>Adicionar todos os arquivos:</b> <code>git add .</code></p>
          <p><b>Fazer commit:</b> <code>git commit -m "Mensagem do commit"</code></p>
          <p><b>Ver histórico:</b> <code>git log --oneline</code></p>
          <p><b>Desfazer último commit (manter alterações):</b> <code>git reset --soft HEAD~1</code></p>
  
          <h2>📌 Stash (Salvar Mudanças Temporariamente)</h2>
          <p><b>Salvar alterações sem commit:</b> <code>git stash</code></p>
          <p><b>Listar stashes salvos:</b> <code>git stash list</code></p>
          <p><b>Aplicar stash mais recente:</b> <code>git stash pop</code></p>
        </div>
  
        <!-- Segunda Coluna -->
        <div class="column">
          <h2>📌 Trabalhando com Branches</h2>
          <p><b>Criar uma branch:</b> <code>git branch nome-da-branch</code></p>
          <p><b>Mudar para uma branch:</b> <code>git checkout nome-da-branch</code></p>
          <p><b>Criar e mudar para a branch:</b> <code>git checkout -b nova-branch</code></p>
          <p><b>Listar branches:</b> <code>git branch</code></p>
          <p><b>Deletar uma branch:</b> <code>git branch -d nome-da-branch</code></p>
  
          <h2>📌 Trabalhando com Repositórios Remotos</h2>
          <p><b>Adicionar repositório remoto:</b> <code>git remote add origin URL</code></p>
          <p><b>Enviar alterações para o remoto:</b> <code>git push origin main</code></p>
          <p><b>Atualizar o repositório local:</b> <code>git pull origin main</code></p>
  
          <h2>📌 Rebase e Reversão</h2>
          <p><b>Reorganizar últimos 3 commits:</b> <code>git rebase -i HEAD~3</code></p>
          <p><b>Reverter um commit já enviado ao remoto:</b> <code>git revert &lt;hash&gt;</code></p>
  
          <h2>📌 Outros Comandos Úteis</h2>
          <p><b>Ver status do repositório:</b> <code>git status</code></p>
          <p><b>Restaurar arquivo não commitado:</b> <code>git checkout -- arquivo.txt</code></p>
          <p><b>Remover um arquivo do Git sem deletá-lo:</b> <code>git rm --cached arquivo.txt</code></p>
        </div>
      </div>
    </div>
  </template>
  
  <style scoped>
  .container {
    max-width: 900px;
    margin: auto;
    padding: 20px;
    text-align: center;
    font-family: "Arial", sans-serif;
  }
  
  h1 {
    font-size: 24px;
    margin-bottom: 10px;
  }
  
  .description {
    font-size: 16px;
    color: #555;
    margin-bottom: 20px;
  }
  
  .cheat-sheet {
    display: flex;
    justify-content: space-between;
    gap: 20px;
  }
  
  .column {
    width: 48%;
    background: #f8f9fa;
    padding: 20px; /* Aumentei o padding */
    border-radius: 8px;
    text-align: left;
    line-height: 1.6; /* Aumentei o espaçamento entre linhas */
  }
  
  h2 {
    font-size: 18px;
    margin-bottom: 10px;
    color: #007bff;
  }
  
  p {
    font-size: 14px;
    margin: 8px 0; /* Mais espaçamento entre os parágrafos */
  }
  
  code {
    background: #e3e3e3;
    padding: 3px 5px;
    border-radius: 5px;
    font-family: monospace;
  }
  </style>
  